import EmptyState from "ds/components/EmptyState";
import { EmptystateShareColored } from "components/icons/generated";
import Box from "ds/components/Box";

const ApiKeyGroupMappingEmpty = () => {
  return (
    <Box align="center" justify="center" grow="1">
      <EmptyState
        title="API key doesn't have any group mappings yet"
        icon={EmptystateShareColored}
      />
    </Box>
  );
};

export default ApiKeyGroupMappingEmpty;
